export const LABEL_RATE_AUTHORIZED_EMAILS = [
  "jordan@getredo.com",
  "josh.thayne@getredo.com",
  "hugh@getredo.com",
  "sam@getredo.com",
  "tommy.wei@getredo.com",
  "will.schaefermeyer@getredo.com",
  "jacob.olson@getredo.com",
  "steven.mitchell@getredo.com",
  "eric@getredo.com",
  "ridge@getredo.com",
  "dylan.wooden@getredo.com",
  "bryce@getredo.com",
  "greg@getredo.com",
  "sperez@getredo.com",
  "bryson@getredo.com",
  "danny.boyer@getredo.com",
  "manny@getredo.com",
  "harrison.walker@getredo.com",
  "harrison@getredo.com",
  "ryan@redo.com",
  "kash@redo.com",
  "spencer.evans@redo.com",
];
